const FOCUSABLE_SELECTORS_LIST = `a[href]:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), area[href], [tabindex="0"], [contenteditable], object, iframe`;

export function startFocusTrap(focusable: Element): () => void {
	const siblings = focusable.parentNode ? Array.from(focusable.parentNode.children).filter(element => element !== focusable) : [];
	const toDisable = siblings.map(sibling => Array.from(sibling.querySelectorAll(FOCUSABLE_SELECTORS_LIST))).flat();
	const disabledElements = toDisable.map(element => {
		const tabIndex = element.hasAttribute("tabindex") ? element.getAttribute("tabindex") : null;
		const ariaHidden = element.hasAttribute("aria-hidden") ? element.getAttribute("aria-hidden") : null;

		element.setAttribute("tabindex", "-1");
		element.setAttribute("aria-hidden", "true");

		return {
			element,
			tabIndex,
			ariaHidden,
		};
	});

	return function stopFocusTrap() {
		disabledElements.forEach(disabled => {
			if (disabled.tabIndex) {
				disabled.element.setAttribute("tabIndex", disabled.tabIndex);
			} else {
				disabled.element.removeAttribute("tabIndex");
			}

			if (disabled.ariaHidden) {
				disabled.element.setAttribute("aria-hidden", disabled.tabIndex);
			} else {
				disabled.element.removeAttribute("aria-hidden");
			}
		});
	};
}
